<script lang="ts">
  import { onMount } from 'svelte';
  // @ts-ignore - module has no TS types
  import { Dashboard } from '@uppy/svelte';
  import { navigate } from 'svelte-navigator';

  import '@uppy/core/dist/style.css';
  import '@uppy/dashboard/dist/style.css';
  import Uppy from '@uppy/core';
  import XHRUpload from '@uppy/xhr-upload';

  // @ts-ignore - module has no TS types
  import German from '@uppy/locales/lib/de_DE';
  import { _ } from 'svelte-i18n';
  import Footer from '../../_shared/footer.svelte';
  import ContactUs from '../../_shared/contact-us.svelte';
  import { identifyDealership } from '../../../lib/services/pdf/identifyDealership';
    import { identifyParts } from '../../../lib/services/pdf/identifyParts';
  import { identifyVinNumber } from '../../../lib/services/pdf/identifyVinNumber';
  import { handleFetchRetry } from '../../handleFetchRetry';
  import LoadingModalBar from '../../_shared/LoadingModalBar.svelte';
  import { errorStore } from '../../../main';
  import Info from '../../../assets/icons/info.svg.svelte';
  import { ut } from '../../../lib/services/pdf/utils';
  import { getStoredReferer } from '../../../utils/utmTracking';
    // @ts-ignore - PNG import type declaration
  import ServiceInvoiceImage from '../../../assets/service-info.png';
  // @ts-ignore - PDF import
  import mbdParticipation from '../../../assets/140 Jahre Cashback-Aktion 2026 -Teilnahmebedingungen_Stand 09-26.pdf';

  onMount(() => {
    // Clean up process keys from localStorage when opening the first step
    localStorage.removeItem('personalInformation');
    localStorage.removeItem('questionsResponses');
    localStorage.removeItem('customerProcess');
    localStorage.removeItem('recognizedText');
    localStorage.removeItem('receipt');
    localStorage.removeItem('reciept');
    localStorage.removeItem('purchasePayBack');
  });

  let response: any;
  let failedAttempts = 0;
  let dealerShipInfo: any;
  let datesIdentified: any;
  let showRetryModal = false;
  let showContactUs = false;
  let onCompleteResponse: any;
  let showExtractedData = false;
  let pdfParserData: any = null;

  let time =
    Date.now ||
    function () {
      return +new Date();
    };

  let loadingState: any = {
    isLoading: false,
    completed: false,
    error: false,
    retry: false,
    functionAfterError: function () {
      closeModal();
    },
    functionAfterCompleted: async function () {
      closeModal();
      // Navigate to personal information step (skipping purchase information)
      navigate('/step/3');
    },
  };

  const convertToDateTime = (dateString: string) => {
    if (!dateString) return new Date();
    let resultDate;
    try {
      if (dateString.includes('.')) {
        let d = dateString?.split('.');
        resultDate = new Date(Date.UTC(+d[2], +d[1] - 1, +d[0]));
      }
      if (dateString.includes('-')) {
        let d = dateString?.split('-');
        resultDate = new Date(Date.UTC(+d[0], +d[1] - 1, +d[2]));
      }
    } catch (error) {
      resultDate = null;
    }
    if (resultDate?.toString() !== 'Invalid Date') {
      return resultDate?.toISOString();
    }
    return null;
  };

  const cleanMileage = (val: string | number | null | undefined): number | null => {
    if (val === null || val === undefined) return null;
    const cleanDigits = String(val).replace(/\D/g, '');
    const parsedMileage = cleanDigits ? parseInt(cleanDigits, 10) : NaN;
    return !isNaN(parsedMileage) ? parsedMileage : null;
  };


  const cleanFirstRegistration = (val: string | null | undefined): string | null => {
    if (val === null || val === undefined) return null;
    const trimmed = String(val).trim();
    if (/^[0.\-/]+$/.test(trimmed) || trimmed === '00.00.1900' || trimmed.toLowerCase() === 'n/a' || trimmed.toLowerCase() === 'na' || trimmed.toLowerCase() === 'null' || trimmed === '') {
      return null;
    }
    return trimmed;
  };


  const closeModal = () => {
    loadingState = {
      ...loadingState,
      isLoading: false,
      error: false,
      retry: false,
    };
  };

  let URL = `${process.env.SVELTE_APP_FE_REMOTE_URL}/api/mbd140`;

  const uppy = new Uppy({
    id: 'files',
    locale: {
      strings: {
        ...German.strings,
        dropPasteFiles:
          `Kopie oder Foto der vollständigen SERVICERECHNUNG hochladen​ hierher ziehen, suchen, oder fotografieren %{browseFiles}`,
          browseFiles: 'hierher ziehen, suchen oder fotografieren.',
        },
    },
    restrictions: {
      allowedFileTypes: ['.jpg', '.jpeg', '.png', 'application/pdf'],
      maxFileSize: 10485760, // 10MB
      maxNumberOfFiles: 10,
    },
  });

  // Generate unique request ID for tracking across multiple pods
  const clientRequestId = `client-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

  uppy.use(XHRUpload, {
    endpoint: `${process.env.SVELTE_APP_REMOTE_URL}/api/extractStep1DataWithGemini`,
    formData: true,
    headers: {
      'X-Custom-Header': 'mb-cashback-2025-header',
      'X-Client-Request-ID': clientRequestId,
    },
    timeout: 0,
    locale: {
      strings: {
        ...German.strings,
        dropPasteFiles:
        `Kopie oder Foto der vollständigen SERVICERECHNUNG hochladen​ hierher ziehen, suchen, oder fotografieren %{browseFiles}`,
        browseFiles: 'hierher ziehen, suchen oder fotografieren.',
      },
    },
    bundle: true,
    fieldName: 'file',
    // metaFields: ['prompt', 'receiptId', 'backupReceiptId' , 'SumActionsEligible'], // Add all fields you want to send
    metaFields: ['prompt'],
    getResponseData: (responseText, response) => {
      const serverPayload = JSON.parse(responseText);
      
      const serverRequestId = (response as any)?.headers?.['x-request-id'] || serverPayload?.requestId;
      if (serverRequestId) {
        console.log('Request correlation:', {
          clientRequestId,
          serverRequestId,
          correlationMatch: serverRequestId.includes(clientRequestId) || clientRequestId.includes(serverRequestId)
        });
      }
      
      return serverPayload;
    },
    getResponseError: (responseText) =>
      new Error(responseText || 'Upload failed'),
  });
  

  uppy.on('upload', (data) => {
    loadingState = {
      ...loadingState,
      error: false,
      completed: false,
    };
    const skipDocumentProcessing =
      process.env.SVELTE_APP_SKIP_DOCUMENT_PROCESSING === 'true';
    if (!skipDocumentProcessing) loadingState.isLoading = true;

    ut('invoice_file_upload_started', { page: '/step/1', timestamp: time() });
  });

  uppy.on('restriction-failed', (file, error) => {
    ut('invoice_file_validation_failed', {
      page: '/file-upload/validation-error-restriction',
      timestamp: time(),
      d: error.toString(),
    });
  });

  uppy.on('retry-all', (d) => {
    loadingState.retry = true;
    ut('invoice_file_upload_retry', {
      page: '/file-upload/retry',
      timestamp: time(),
      d: d.toString(),
    });
  });

  uppy.on('file-added', (file) => {
    uppy.setFileMeta(file.id, {
      prompt: 'Extract all information as much as possible from the document',
    });

    ut('invoice_file_added', { page: '/step/1', timestamp: time() });
  });

  uppy.on('file-removed', (d) => {
    ut('invoice_file_removed', { page: '/step/1', timestamp: time() });
  });

  uppy.on('error', (d) => {
    ut('invoice_file_upload_error', {
      page: '/file-upload/error',
      timestamp: time(),
      d: d.toString(),
    });

    if (failedAttempts < 3) {
      failedAttempts++;

      setTimeout(() => {
        uppy.retryAll();
      }, 5000);
    } else {
      loadingState.error = true;

      showContactUs = true;
      ut('invoice_file_upload_error_contact_form_shown', {
        page: '/step/1',
        timestamp: time(),
        failedAttempts: failedAttempts,
      });
    }
  });

  uppy.on('upload-error', (file, error, response) => {
    ut('invoice_file_upload_network_error', {
      page: '/file-upload/upload-error',
      timestamp: time(),
      d: error.toString(),
    });

    if (failedAttempts < 3) {
      failedAttempts++;

      setTimeout(() => {
        uppy.retryAll();
      }, 5000);
    } else {
      loadingState.error = true;

      showContactUs = true;
      ut('invoice_file_upload_failed_contact_form_shown', {
        page: '/step/1',
        timestamp: time(),
        failedAttempts: failedAttempts,
      });
    }
  });

  uppy.on('complete', async (r: any) => {
    onCompleteResponse = r;

    localStorage.setItem(
      'customerProcess',
      JSON.stringify({
        registration: false,
      }),
    );
    ut('invoice_file_upload_completed', { page: '/step/1', timestamp: time() });

    if (r.successful && r.successful.length > 0) {
      const URL = `${process.env.SVELTE_APP_FE_REMOTE_URL}/api/mbd140`;

      try {
        const body = r.successful?.[0].response.body;
        const extracted = body?.extractedData || {};
        const receiptId = body?.receiptId;
        const backupReceiptId = body?.backupReceiptId;
        const fileUrls = body?.fileUrls || {};
        const invoiceUrl = fileUrls || '';

        localStorage.setItem('recognizedText', JSON.stringify(body));

        response = extracted;

        const dealershipName = extracted?.DealershipName ?? '';
        const dealershipAddress = extracted?.DealershipAddress?.zipCode
          ? `${extracted?.DealershipAddress?.street ?? ''} ${extracted?.DealershipAddress?.zipCode ?? ''}`.trim()
          : (extracted?.DealershipAddress?.street ?? '');
        dealerShipInfo = await identifyDealership(
          `${dealershipName}${dealershipAddress ? `, ${dealershipAddress}` : ''}`,
          extracted?.DealershipLocation,
        );

        const partsInfo = await identifyParts(extracted);

        datesIdentified = (extracted?.InvoiceDate || '').replaceAll(' ', '');
        let yearIdentified = datesIdentified?.split('.')[2];
        if (yearIdentified && yearIdentified.length == 2) {
          let day = datesIdentified.split('.')[0];
          let month = datesIdentified.split('.')[1];
          datesIdentified = `${day}.${month}.20${yearIdentified}`;
        }

        const cashbackData = extracted?.Cashback || {
          Switch: { explicit: false, relaxed: false, description: '' },
          Storage: { explicit: false, relaxed: false, description: '' },
          eligibility: { basic: false, full: false },
        };

        const switchDetected = cashbackData.Switch?.explicit || cashbackData.Switch?.relaxed;
        const storageDetected = cashbackData.Storage?.explicit || cashbackData.Storage?.relaxed;

        const storageDesc = cashbackData.Storage?.description || '';
        const switchDesc = cashbackData.Switch?.description || '';

        let cashbackType = 'cashback-basic';
        if (switchDetected && storageDetected) {
          cashbackType = 'cashback-full';
        } else if (switchDetected) {
          cashbackType = 'cashback-basic';
        } else {
          cashbackType = 'cashback-basic';
        }

        const receiptPayload = {
          rekognitionResponseStep1: JSON.stringify(extracted),
          dealershipsId: dealerShipInfo?.id
            ? parseInt(dealerShipInfo?.id, 10)
            : undefined,
          dealershipIdentified: dealershipName || 'Unknown',
          partsCount: `${partsInfo?.partsCount ?? 0}`,
          partsId: JSON.stringify(partsInfo?.partsId ?? []),
          partsIdentified: JSON.stringify(partsInfo?.partsIdentified ?? []),
          storageIdentified: storageDesc,
          switchIdentified: switchDesc,
          storage: storageDesc,
          switch: switchDesc,
          storageOverride: '0',
          switchOverride: '0',
          vehicleVin: extracted?.VehicleIdentificationNumber || 'Unknown',
          vehicleVinIdentified: identifyVinNumber(extracted?.VehicleIdentificationNumber) || extracted?.VehicleIdentificationNumber || 'Unknown',
          vehicleVersion: extracted?.VehicleType || 'Unknown',
          datesIdentified,
          purchaseDate: convertToDateTime(datesIdentified),
          raw: JSON.stringify(invoiceUrl),
          totalSpareParts: extracted?.TotalSpareParts?.TotalSparePartsSpecific || '',
          totalLaborCosts: extracted?.TotalLaborCosts?.TotalLaborCostsSpecific || '',
          totalSparePartsIdentified: extracted?.TotalSpareParts?.TotalSparePartsSpecific || '',
          totalLaborCostsIdentified: extracted?.TotalLaborCosts?.TotalLaborCostsSpecific || '',
          invoiceNumber: extracted?.InvoiceNumber || '',
          invoiceNumberIdentified: extracted?.InvoiceNumber || '',
          cashbackEligible: cashbackData?.eligibility?.cashbackEligible ?? 0,
          sumPartEligible: extracted?.TotalSpareParts?.SumPartEligible ?? 0,
          totalInvoiceCost: extracted?.TotalAmount || '',
          invoiceDate: extracted?.InvoiceDate || '',
          firstRegistration: cleanFirstRegistration(extracted?.FirstRegistration),
          mileage: cleanMileage(extracted?.Mileage),
        };

        // Ensure no navigational properties are sent to Loopback
        // @ts-ignore
        delete receiptPayload.dealerships;

        await handleFetchRetry(() =>
          fetch(`${URL}/purchasereceipts/${receiptId}`, {
            method: 'PATCH',
            headers: {
              Accept: 'application/json, text/plain',
              'Content-Type': 'application/json;charset=UTF-8',
              'X-Custom-Header': 'mb-cashback-2025-header',
            },
            body: JSON.stringify(receiptPayload),
          }),
        );

        await handleFetchRetry(() =>
          fetch(`${URL}/purchasereceipts-backups/${backupReceiptId}`, {
            method: 'PATCH',
            headers: {
              Accept: 'application/json, text/plain',
              'Content-Type': 'application/json;charset=UTF-8',
              'X-Custom-Header': 'mb-cashback-2025-header',
            },
            body: JSON.stringify(receiptPayload),
          }),
        );

        const receiptData = { id: receiptId, ...receiptPayload };

        const payback = await handleFetchRetry(() =>
          fetch(`${URL}/purchasepaybacks`, {
            method: 'POST',
            headers: {
              Accept: 'application/json, text/plain',
              'Content-Type': 'application/json;charset=UTF-8',
              'X-Custom-Header': 'mb-cashback-2025-header',
            },
            body: JSON.stringify({
              purchasereceiptsId: parseInt(receiptData.id, 10),
              completed: 0,
              status: 'VERIFICATION',
              cashbackType: cashbackType,
              referer: getStoredReferer(),
            }),
          }),
        );
        const paybackData = await payback.json();

        localStorage.setItem('purchasePayBack', JSON.stringify(paybackData));
        localStorage.setItem('receipt', JSON.stringify(receiptData));

        localStorage.setItem(
          'customerProcess',
          JSON.stringify({ registration: true }),
        );

        loadingState.completed = true;
        showExtractedData = true;
        pdfParserData = { result: extracted };
      } catch (e) {
        console.error('Error processing uploaded files:', e);
        if (e instanceof Error) {
          errorStore.set({
            message: e.message,
            source: e.message,
            lineno: e.message,
            colno: e.message,
            error: e.message,
          });
        }
      }
    }
  });

  let readMore = false;

  let max_content_height: number = 0;
  let content_height: number;
  let screen_width: number;
  $: show_read_more =
    readMore || screen_width > 640
      ? content_height > max_content_height
      : content_height >= max_content_height;

  const handleReadMore = () => {
    readMore = !readMore;
  };

  const handleContactFormSubmit = () => {
    showContactUs = false;
    failedAttempts = 0;
    loadingState.error = false;

    ut('contact_form_submitted_after_parsing_failure', {
      page: '/step/1',
      timestamp: time(),
    });

    navigate('/step/1');
  };

  const continueWithOutRecognition = async () => {
    localStorage.removeItem('recognizedText');
    localStorage.removeItem('purchasePayBack');
    localStorage.removeItem('reciept');

    localStorage.setItem(
      'customerProcess',
      JSON.stringify({
        registration: false,
      }),
    );

    try {
      const receipt = await fetch(`${URL}/purchasereceipts`, {
        method: 'POST',
        headers: {
          Accept: 'application/json, text/plain',
          'Content-Type': 'application/json;charset=UTF-8',
          'X-Custom-Header': 'mb-cashback-2025-header',
        },
        body: JSON.stringify({
          rekognitionResponseStep1: JSON.stringify({}),
          raw: '',
        }),
      });
      const receiptData = await receipt.json();
      const payback = await handleFetchRetry(() =>
        fetch(`${URL}/purchasepaybacks`, {
          method: 'POST',
          headers: {
            Accept: 'application/json, text/plain',
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Custom-Header': 'mb-cashback-2025-header',
          },
          body: JSON.stringify({
            purchasereceiptsId: parseInt(receiptData.id, 10),
            completed: 0,
            status: 'VERIFICATION',
            cashbackType: 'cashback-basic',
            referer: getStoredReferer(),
          }),
        }),
      );
      const paybackData = await payback.json();

      localStorage.setItem('purchasePayBack', JSON.stringify(paybackData));
      localStorage.setItem('receipt', JSON.stringify(receiptData));

      // Navigate to personal information step (skipping purchase information)
      navigate('/step/3');
    } catch (e) {
      console.error('Error continuing without recognition:', e);
    }
  };
</script>

<svelte:window bind:innerWidth={screen_width} />
<div class="flex flex-1 flex-col space-y-6">
  <div>
    <h1 class="font-CorpoA text-3xl text-black capitalize">
      {$_('Service Invoice')}
    </h1>
  </div>

  <div
    bind:clientHeight={max_content_height}
    id="parent"
    class={readMore ? 'overflow-y-visible' : 'overflow-y-hidden'}
    style="height: ${content_height}px"
  >
    <div
      class="max-w-4xl font-CorpoS text-base leading-relaxed text-cubiq-grey-font"
    >
      <div bind:clientHeight={content_height} class="flex flex-col space-y-4">
        <p>
          {$_('Service Invoice Intro Text')}
        </p>
        <p>
          {$_(
            'Service Invoice Intro Text 2',
          )}
        </p>
        <p>
          {$_(
            'Secure your cashback amount',
          )}
        </p>
          <!-- Important Notice Box -->
        <div class="rounded-lg bg-gray-100 px-5 py-3">
          <h2 class="mb-1 font-CorpoA text-base font-bold text-red-600">
            {$_('Important Notice Headline')}
          </h2>
          <p class="mb-1 font-CorpoS text-base leading-relaxed text-red-600">
            {$_('Important Notice Line 1')}
          </p>
          <p class="mb-1 font-CorpoS text-base leading-relaxed text-red-600">
            {$_('Important Notice Line 2')}
          </p>
          <p class="mb-1 font-CorpoS text-base leading-relaxed text-gray-800">
            {$_('Important Notice Line 3')}
          </p>
          <p class="mb-1 font-CorpoS text-base leading-relaxed text-gray-800">
            {$_('Important Notice Line 4')}
          </p>
          <p class="mb-1 font-CorpoS text-base text-gray-800">
            {$_('Important Notice Footer')} <a href={mbdParticipation} target="_blank" rel="noopener noreferrer" class="font-medium text-primary-600 underline hover:text-primary-800">{$_('Terms and Conditions')}</a>.
          </p>
        </div>

        <div class="flex items-start space-x-3">
          <Info
            class="mt-0.5 h-5 w-5 flex-shrink-0 text-cubiq-light-blue-600"
          />
          <div class="flex-1">
            <p
              class="mb-2 text-sm font-medium leading-relaxed text-cubiq-dark-blue"
            >
              {$_('Service Invoice Upload Info')}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    {#if !readMore && show_read_more}
      <div>
        <div
          class="pointer-events-none relative z-10 -mt-[108px] min-h-[100px] w-full bg-gradient-to-t from-white to-transparent sm:-mt-[116px]"
        />
      </div>
    {/if}

    {#if show_read_more}
      <div class="mb-4 flex justify-start">
        <button
          class="font-CorpoS text-base text-cubiq-dark-blue transition-colors hover:text-cubiq-dark-blue-800"
          on:click={handleReadMore}
          >{readMore ? $_('Read less') : $_('Read more')}</button
        >
      </div>
    {/if}
  </div>

  <div class="grid grid-cols-1 items-center gap-6 rounded-lg border border-gray-200 px-6 py-2 md:grid-cols-[3fr_2fr]">
    <div class="relative order-2 md:order-1">
      {#if loadingState.isLoading}
        <LoadingModalBar bind:loadingState />
      {/if}
      <Dashboard
        {uppy}
        props={{
          height: 200,
          inline: true,
        }}
      />
    </div>
    <div class="flex flex-col items-center space-y-6 order-1 md:order-2">
      <p class="font-CorpoS text-sm font-medium text-black">
        {$_('Service Invoice Example Image')}
      </p>
      <img
        src={ServiceInvoiceImage}
        alt={$_('Service Invoice Example Image')}
        class="max-w-[250px] w-full object-contain" 
        />
    </div>
  </div>

  <!-- Display extracted data from backend response -->
  {#if showExtractedData && pdfParserData?.result}
    <div class="mt-6 rounded-lg border border-gray-200 bg-gray-50 p-6">
      <h3 class="mb-4 text-lg font-semibold text-cubiq-dark-blue">
        Extracted Information from PDF
      </h3>

      <div class="grid grid-cols-1 gap-4 text-sm md:grid-cols-2">
        <!-- Customer Information -->
        <div class="space-y-2">
          <h4 class="font-medium text-cubiq-dark-blue">Customer Information</h4>
          <div class="space-y-1">
            <p>
              <span class="font-medium">Name:</span>
              {pdfParserData.result.CustomerName || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Customer Number:</span>
              {pdfParserData.result.CustomerNumber || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Address:</span>
              {pdfParserData.result.CustomerAddress?.street || ''}
              {pdfParserData.result.CustomerAddress?.zipCode || ''}
            </p>
          </div>
        </div>

        <!-- Dealership Information -->
        <div class="space-y-2">
          <h4 class="font-medium text-cubiq-dark-blue">
            Dealership Information
          </h4>
          <div class="space-y-1">
            <p>
              <span class="font-medium">Name:</span>
              {pdfParserData.result.DealershipName || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Location:</span>
              {pdfParserData.result.DealershipLocation || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Address:</span>
              {pdfParserData.result.DealershipAddress?.street || ''}
              {pdfParserData.result.DealershipAddress?.zipCode || ''}
            </p>
            <p>
              <span class="font-medium">Contact:</span>
              {pdfParserData.result.ContactPerson || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Phone:</span>
              {pdfParserData.result.PhoneNumber || 'N/A'}
            </p>
          </div>
        </div>

        <!-- Vehicle Information -->
        <div class="space-y-2">
          <h4 class="font-medium text-cubiq-dark-blue">Vehicle Information</h4>
          <div class="space-y-1">
            <p>
              <span class="font-medium">Type:</span>
              {pdfParserData.result.VehicleType || 'N/A'}
            </p>
            <p>
              <span class="font-medium">VIN:</span>
              {pdfParserData.result.VehicleIdentificationNumber || 'N/A'}
            </p>
            <p>
              <span class="font-medium">License Plate:</span>
              {pdfParserData.result.LicensePlate || 'N/A'}
            </p>
            <p>
              <span class="font-medium">First Registration:</span>
              {pdfParserData.result.FirstRegistration || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Mileage:</span>
              {pdfParserData.result.Mileage || 'N/A'}
            </p>
          </div>
        </div>

        <!-- Invoice Information -->
        <div class="space-y-2">
          <h4 class="font-medium text-cubiq-dark-blue">Invoice Information</h4>
          <div class="space-y-1">
            <p>
              <span class="font-medium">Invoice Number:</span>
              {pdfParserData.result.InvoiceNumber || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Invoice Date:</span>
              {pdfParserData.result.InvoiceDate || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Order Date:</span>
              {pdfParserData.result.OrderDate || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Delivery Date:</span>
              {pdfParserData.result.DeliveryDate || 'N/A'}
            </p>
            <p>
              <span class="font-medium">Total Amount:</span>
              {pdfParserData.result.TotalAmount || 'N/A'}
            </p>
          </div>
        </div>
      </div>

      <!-- Service Descriptions -->
      {#if pdfParserData.result.Description1 || pdfParserData.result.Description2 || pdfParserData.result.Description3}
        <div class="mt-4 space-y-2">
          <h4 class="font-medium text-cubiq-dark-blue">Services Performed</h4>
          <div class="space-y-1">
            {#if pdfParserData.result.Description1}
              <p>• {pdfParserData.result.Description1}</p>
            {/if}
            {#if pdfParserData.result.Description2}
              <p>• {pdfParserData.result.Description2}</p>
            {/if}
            {#if pdfParserData.result.Description3}
              <p>• {pdfParserData.result.Description3}</p>
            {/if}
          </div>
        </div>
      {/if}

      <!-- Raw JSON for debugging -->
      <details class="mt-4">
        <summary class="cursor-pointer font-medium text-cubiq-dark-blue">
          View Raw Extracted Data (for debugging)
        </summary>
        <pre class="mt-2 overflow-auto rounded bg-gray-100 p-3 text-xs">
{JSON.stringify(pdfParserData.result, null, 2)}
        </pre>
      </details>
    </div>
  {/if}

  <div class="space-y-4">
    <div class="max-w-4xl font-CorpoS text-base text-cubiq-grey-font">
      <div class="flex flex-col space-y-3">
        <div class="flex items-start space-x-3">
          <Info
            class="mt-0.5 h-5 w-5 flex-shrink-0 text-cubiq-light-blue-600"
          />
          <div class="flex-1">
            <p
              class="mb-2 text-sm font-medium leading-relaxed text-cubiq-dark-blue"
            >
              {$_('Service Invoice Multiple Files Info')}
            </p>
          </div>
        </div>
        <div class="flex items-start space-x-3">
          <Info
            class="mt-0.5 h-5 w-5 flex-shrink-0 text-cubiq-light-blue-600"
          />
          <div class="flex-1">
            <p
              class="mb-2 text-sm font-medium leading-relaxed text-cubiq-dark-blue"
            >
              {$_('Service Invoice Patience Info')}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sticky bottom-0 flex w-full justify-end bg-white py-2 sm:py-4">
    <div class="block pr-4 sm:hidden">
      <Footer />
    </div>
  </div>

  {#if showRetryModal}
    <div
      class="fixed inset-0 z-50 overflow-y-hidden"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="block min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center"
      >
        <div
          class="fixed inset-0 bg-cubiq-grey-900 bg-opacity-50 transition-opacity"
          aria-hidden="true"
        />

        <div
          class="relative my-56 inline-block transform overflow-hidden bg-white px-6 pt-6 pb-6 text-left align-middle font-CorpoS text-base transition-all sm:w-full sm:max-w-screen-md sm:p-8"
        >
          <div class="mb-6">
            <p class="leading-relaxed text-cubiq-grey-font">
              {$_(
                `The information on your picture could not be recognised. Please click on Cancel to try upload another picture/file or click on 'next' to enter the information manually.`,
              )}
            </p>
          </div>
          <div class="flex justify-end space-x-4">
            <button
              class="bg-red-600 px-6 py-3 font-medium text-white transition-colors hover:bg-red-700"
              data-umami-event="cancel button clicked"
              data-umami-event-page="/step/1"
              on:click={() => {
                showRetryModal = false;
              }}>{$_('Cancel')}</button
            >
            <button
              class="bg-cubiq-dark-blue px-6 py-3 font-medium text-white transition-colors hover:bg-cubiq-dark-blue-800"
              data-umami-event="next w/o upload button clicked"
              data-umami-event-page="/step/1"
              on:click={() => {
                continueWithOutRecognition();
              }}>{$_('Next')}</button
            >
          </div>
        </div>
      </div>
    </div>
  {/if}

  {#if showContactUs}
    <ContactUs on:submit={handleContactFormSubmit} bind:showContactUs />
  {/if}
</div>

